import { camelize } from "camelscore";
import {
  get as getFromCache,
  put as putToCache,
} from "storefront/lib/memoryCache";
import type { PublicConfig } from "../../../Config/PublicConfig";
import { get } from "../../request";

type Response = {
  data: PublicConfig;
};

export const CACHE_KEY = "public_config";

const unpack = ({ data }: Response): PublicConfig => data;

export const updateCache = (data: PublicConfig): void =>
  putToCache(CACHE_KEY, data);

const getConfig = (): Promise<PublicConfig> => {
  if (typeof window !== "undefined" && window.PUBLIC_CONFIG) {
    const windowValue = camelize(window.PUBLIC_CONFIG);
    updateCache(windowValue);
    return Promise.resolve(windowValue);
  }
  const cachedValue = getFromCache(CACHE_KEY);
  if (cachedValue) {
    return Promise.resolve(cachedValue);
  }
  return get<Response>("/api/config")
    .then(unpack)
    .then((data) => {
      putToCache(CACHE_KEY, data);
      return data;
    });
};

export const getConfigSync = (): PublicConfig => {
  if (typeof window !== "undefined" && window.PUBLIC_CONFIG) {
    const windowValue = camelize(window.PUBLIC_CONFIG);
    updateCache(windowValue);
    return windowValue;
  }

  const cachedValue = getFromCache(CACHE_KEY);

  if (cachedValue) {
    return cachedValue;
  }

  throw new Error(
    "PublicConfig is not available synchronously. Ensure getConfig() has been called during SSR or that window.PUBLIC_CONFIG is set.",
  );
};

export default getConfig;
